import { API_BASE_URL } from './constants';

/**
 * Plan 268: la foto del producto.
 *
 * La copia propia llega como ruta (`/api/public/product-images/…`). En PROD el
 * frontend y la API están en orígenes distintos, así que hay que pedírsela a la
 * API; con proxy de mismo origen `API_BASE_URL` es '' y queda igual. Las URL
 * absolutas (fotos viejas, de antes de la copia propia) no se tocan.
 */
export function urlDeImagen(url: string | null | undefined): string | null {
  if (!url) return null;
  return url.startsWith('/api/') ? `${API_BASE_URL}${url}` : url;
}

export interface AvisoDeImagen {
  texto: string;
  detalle: string;
  tono: 'info' | 'alerta';
}

export function avisoDeImagen(p: {
  imageStatus?: string | null;
  imageError?: string | null;
}): AvisoDeImagen | null {
  if (p.imageStatus === 'PENDING') {
    return {
      texto: 'Foto en camino',
      detalle: 'Prixia está descargando la foto del enlace que llegó con el catálogo.',
      tono: 'info',
    };
  }
  if (p.imageStatus === 'FAILED') {
    return {
      texto: 'Foto sin descargar',
      detalle: p.imageError || 'No se pudo descargar la imagen.',
      tono: 'alerta',
    };
  }
  return null;
}
